'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@/lib/utils';
type HeroBannerCarouselDotsProps = {
  count: number;
  current: number;
  showShadow?: boolean;
};
export default function HeroBannerCarouselDots(t0) {
  const $ = _c(10);
  const {
    count,
    current,
    showShadow: t1
  } = t0;
  const showShadow = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== count) {
    t2 = Array.from({
      length: count
    });
    $[0] = count;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== current || $[3] !== t2) {
    t3 = <div className="flex items-center gap-2">{t2.map((_, index) => <span key={index} className={cn("rounded-full transition-all duration-300", index === current ? "h-1.5 w-6 rounded-lg bg-[#00b3e3]" : "size-1.5 bg-[#364356]")} />)}</div>;
    $[2] = current;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== showShadow) {
    t4 = showShadow && <div className="pointer-events-none absolute -bottom-[200px] h-[500px] w-full bg-[radial-gradient(60%_50%_at_50%_50%,rgba(83,255,246,0.5)_0%,rgba(79,216,245,0.25)_40%,rgba(79,216,245,0.1)_70%,rgba(79,216,245,0)_100%)] opacity-30" />;
    $[5] = showShadow;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div data-component="hero-carousel-dots" className="relative flex w-full justify-center py-4">{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}